import { Flex, Skeleton } from "antd";

export default function ReviewListLoading() {
  return (
    <section className="p-6 rounded-xl border border-theme-slate-200 space-y-4">
      {[1, 2, 3].map((item) => (
        <div
          key={item}
          className="border-b border-theme-zinc-200 pb-3 last:border-b-0 last:pb-0"
        >
          <Flex align="center" justify="space-between" wrap gap={16}>
            <Flex align="center" gap={12}>
              <Skeleton.Avatar active size={56} />
              <Flex className="flex-col">
                <Skeleton.Button active size="small" className="!w-32 mb-1" />
                <Skeleton.Button active size="small" className="!w-24" />
              </Flex>
            </Flex>

            <Skeleton.Input active size="small" className="!w-32" />
          </Flex>

          <div className="mt-3 space-y-2">
            <Skeleton.Input active size="small" className="!w-full" />
            <Skeleton.Input active size="small" className="!w-full" />
            <Skeleton.Input active size="small" className="!w-3/4" />
          </div>
        </div>
      ))}
    </section>
  );
}
